import "./logo.svg";
import "./logo-white.svg";
import "./logo-plus-kitazato.svg";
import "./logo-plus-kitazato-white.svg";
import "./icon-calendar.svg";
import "./icon-clock.svg";
import "./icon-link.svg";
import "./icon-linkedin.svg";
import "./icon-whatsapp-share.svg";
import "./icon-email.svg";
import "./icon-arrow-to-r.svg";
import "./rtdigital.svg";
